import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import { useParams } from "react-router";
import "./faqs.scss";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from "../../common/accordion";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { TabTitle } from "../../common/dynamicTitle";
import Breadcrumbs from "../../common/breadcumb";
import { LangContext } from "../../context/LangContext";
function Faqs() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams();

  const pageTitle = useMemo(() => (nep ? "प्रश्नोत्तर" : "FAQS"), [nep]);
  TabTitle(`GMBF | ${pageTitle}`);

  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const APIURL = `${process.env.REACT_APP_URL}/faq`;

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await axios.get(APIURL);
        setFaqs(response.data.items);
        // console.log("FAQ data:", response.data.items);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, [slug]);

  const mainData = useMemo(() => {
    if (!faqs) return null;
    return nep ? faqs.np : faqs.en;
  }, [faqs, nep]);

  if (loading) return <Loading />;
  if (error) return <Errors />;

  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <div className="InsidePageContainer">
        <div className="faq-box">
          <div className="wrapper">
            <div className="faq-container">
              {mainData?.length === 0 ? (
                "No Content Found"
              ) : (
                <Tabs>
                  <TabList>
                    {mainData?.map((cat, index) => (
                      <Tab key={index}>{cat.title}</Tab>
                    ))}
                  </TabList>

                  {mainData?.map((cat, index) => (
                    <TabPanel key={index}>
                      <div
                        className="accordion"
                        id={`accordionExample-${index}`}
                      >
                        {cat.child?.length === 0
                          ? "No Content Found"
                          : cat.child.map((faq, faqIndex) => (
                              <div key={faqIndex} className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id={`heading-${faqIndex}`}
                                >
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse-${faqIndex}`}
                                    aria-expanded="true"
                                    aria-controls={`collapse-${faqIndex}`}
                                  >
                                    {faq?.title}
                                  </button>
                                </h2>
                                <div
                                  id={`collapse-${faqIndex}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`heading-${faqIndex}`}
                                  data-bs-parent={`#accordionExample-${index}`}
                                >
                                  <div className="accordion-body">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: faq?.description,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                      </div>
                    </TabPanel>
                  ))}
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Faqs;
